import { Link } from 'react-router-dom';
import { DocSection } from '../../../pages/shell';

export const toc = [
  { id: 'pick-problem', label: 'Pick your problem' },
  { id: 'still-stuck', label: 'Still stuck?' },
];

export default function Body() {
  return (
    <>
      <DocSection id="pick-problem" title="Pick your problem">
        <p>
          Find the sentence closest to what you are seeing, and jump straight to the fix — no need
          to read anything else on this page.
        </p>
        <ul>
          <li>
            <strong><Link to="/docs/troubleshooting/gpu-not-detected">ClipRadar won't start, or Settings shows a red compute warning</Link></strong>
            {' '}— ClipRadar needs a CUDA-capable NVIDIA GPU and hasn't found one, or a driver update
            is overdue.
          </li>
          <li>
            <strong><Link to="/docs/troubleshooting/panel-wont-open">The Premiere panel isn't in the Window menu, or opens blank</Link></strong>
            {' '}— the panel extension needs reinstalling, or it can't reach the desktop app.
          </li>
          <li>
            <strong><Link to="/docs/troubleshooting/cant-search">Search comes back empty, or asks for a license</Link></strong>
            {' '}— walk the analyze → included-in-search → licensed checks in order.
          </li>
          <li>
            <strong><Link to="/docs/troubleshooting/analysis-and-files">A file won't finish analyzing, shows missing, or has no transcript</Link></strong>
            {' '}— interrupted model downloads, moved files, and damaged audio, covered together.
          </li>
          <li>
            <strong><Link to="/docs/troubleshooting/known-issues">None of the above — something else looks off</Link></strong>
            {' '}— check the known issues list before assuming it's new.
          </li>
        </ul>
      </DocSection>
      <DocSection id="still-stuck" title="Still stuck?">
        <p>
          If none of these pages get you unstuck,{' '}
          <Link to="/docs/get-help#report-bug">report a bug from inside ClipRadar</Link> — it's the
          fastest way to get a real person looking at your exact situation — or drop the question
          in <Link to="/docs/get-help#discord">Discord</Link>.
        </p>
      </DocSection>
    </>
  );
}
